export default __webpack_public_path__ + "static/media/profile_dummy.d5a2ce9d.svg";